"use client";

import dynamic from "next/dynamic";
import type { SensorWithStatusEntry } from "@/utils/supabase/types";
import type { MapProps } from "./Map";
import { MapLoading } from "./MapLoading";

const Map = dynamic(() => import("./Map"), {
	loading: MapLoading,
	ssr: false,
});

export type SensorMapProps = Omit<MapProps, "sensors"> & {
	sensors?: SensorWithStatusEntry[];
};

export function SensorMap({ isWaterSensor, sensors, ...rest }: SensorMapProps) {
	const filteredSensors = sensors?.filter(sensor => {
		return isWaterSensor ? sensor.category === "Sjókvíar" : sensor.category !== "Sjókvíar";
	});

	return <Map isWaterSensor={isWaterSensor} sensors={filteredSensors} {...rest} />;
}
